import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Apollo } from 'apollo-angular';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { Container } from '../../containers/container';
import { TimeEntryCategory } from '../../entities/timeEntryCategory/timeEntryCategory';
import { LoadingService } from '../../services/loading.service';
import { EditDialogService } from '../editDialog/editDialogService';
import { TimeEntryCategoryDialogDialogComponent } from '../time-entry-category-dialog/time-entry-category-dialog.component';
import * as fromGraphQl from './graphql';


interface Setting {
  key: string;
  value: any;
}

@Component({
  selector: 'app-time-entry-category-view',
  templateUrl: './time-entry-category-view.component.html',
  styleUrls: ['./time-entry-category-view.component.scss']
})
export class TimeEntryCategoryViewComponent
  extends Container<fromGraphQl.TimeEntryCategoryQueryResponse>
  implements OnInit, OnDestroy {

  dialogRef: DynamicDialogRef | undefined;

  public timeEntryCategory: TimeEntryCategory;
  public id: string;
  public routeSubscription: Subscription;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    loadingService: LoadingService,
    apollo: Apollo,
    public dialogService: EditDialogService,
    @Inject('env') environment : any
  ) {
    super(apollo, loadingService, fromGraphQl.TIME_ENTRY_CATEGORY_QUERY, environment);
  }

  ngOnInit(): void {
    this.routeSubscription = this.route.params
      .pipe(
        filter((params) => params['id'] !== undefined),
        take(1)
      )
      .subscribe((params) => {
        this.id = params['id'];
        this.subscribeToQuery({
          id: this.id,
        });
      });
  }

  ngOnDestroy(): void {
    this.routeSubscription?.unsubscribe();
    super.ngOnDestroy();
  }

  handleSubscriptionResult(data: fromGraphQl.TimeEntryCategoryQueryResponse): void {
    this.loadingService.setLoading(false);
    if (data) {
      this.queryRef.stopPolling();
      if (data.timeEntryCategory) {
        this.timeEntryCategory = new TimeEntryCategory(data.timeEntryCategory);
      }
    }
  }


  editTimeEntryCategory(): void {
    this.dialogRef = this.dialogService.open(TimeEntryCategoryDialogDialogComponent, {
      header: 'Kategorie editieren',
      data: this.timeEntryCategory
    });
    this.dialogRef.onClose.subscribe((result) => {
      // result is true or false, indiciating if it should refetch
      if(result){
        this.queryRef.refetch();
      }
    });
  }

  
}
